import $ from 'jquery'
import { lockBody, unlockBody } from "../_utils";

let trainingRecapOpen = false;

$(document).on('click', '.js-open-recap', function (e) {
    e.preventDefault();

    $('.js-training-recap').addClass('is-open');

    trainingRecapOpen = true;
    lockBody();
});

$(document).on('click', '.js-close-recap', function (e) {
    e.preventDefault();

    $('.js-training-recap').removeClass('is-open');

    trainingRecapOpen = false;
    unlockBody();
});

$(document).on('click', '.js-close-recap-and-go-to-calendar', function (e) {
    e.preventDefault();

    $('.js-training-recap').removeClass('is-open');

    trainingRecapOpen = false;
    unlockBody();

    $('html, body').animate({
        scrollTop: $('#calendrier').offset().top
    }, 500);
});

const media = window.matchMedia('(min-width: 992px)');

media.addEventListener('change', function (e) {
    if (e.matches) {
        trainingRecapOpen = false;

        unlockBody();

        $('.js-training-recap').removeClass('is-open');
    }
});

const $summary = $('.js-summary');
const $headings = $('.single-training__content h2');

$headings.each(function (index) {
    const $heading = $(this);

    let id = $heading.attr('id');

    if (!id) {
        id = `section-${index + 1}`;
        $heading.attr('id', id);
    }

    $summary.append(`
        <li class="accordion__summary-item">
            <a href="#${id}" class="accordion__summary-link">
                ${$heading.text()}
            </a>
        </li>
    `);
});

$summary.on('click', '.accordion__summary-link', function (e) {
    e.preventDefault();

    const $target = $($(this).attr('href'));

    if ($target.length) {
        $('html, body').animate({
            scrollTop: $target.offset().top - 100
        }, 500);
    }
});